import React, { FC, ReactNode } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
}

const PageHeader: FC<IProps> = ({ children }) => {
  return <div className={css.page__header}>{children}</div>;
};

export default PageHeader;
